module.exports = __webpack_public_path__ + "img/avi.fe90a0b5.png";